import { AlertColor } from '@mui/material';
import { NotificationsStack, useNotificationsContext } from 'pvs-design-system';
import React from 'react';

let notificationsContext: ReturnType<typeof useNotificationsContext>;

export const Notifications: React.FC = () => {
  notificationsContext = useNotificationsContext();
  return <NotificationsStack maxDisplayed={3} />;
};

const notify = (severity: AlertColor, message: string | React.ReactNode) => {
  notificationsContext.addNotification({
    severity,
    children: message,
  });
};

export const Notify = {
  success(message: string | React.ReactNode) {
    notify('success', message);
  },
  warning(message: string | React.ReactNode) {
    notify('warning', message);
  },
  info(message: string | React.ReactNode) {
    notify('info', message);
  },
  error(message: string | React.ReactNode) {
    notify('error', message);
  },
};

export default Notifications;
